import { apiSlice } from '../api/apiSlice'
import { RequestProps } from '../../types'
import DictionariesResponse from '../../types/response/DictionariesResponse'
import Dictionary from '../../types/models/Dictionary'

export type ImportDictionary = Record<string, string[]>

const commonUrl = '/dictionaries'

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getDictionaries: builder.query<DictionariesResponse, RequestProps>({
      query: (props: RequestProps) => ({
        url: commonUrl,
        params: props,
      }),
      providesTags: () => [{ type: 'Dictionary', id: 'LIST' }],
    }),
    getDictionary: builder.query<Dictionary, string>({
      query: (id: string) => `${commonUrl}/${id}`,
      providesTags: () => [{ type: 'Dictionary', id: 'LIST' }],
    }),
    createDictionary: builder.mutation({
      query: (dictionary: Partial<Dictionary>) => ({
        url: commonUrl,
        method: 'POST',
        body: dictionary,
      }),
      invalidatesTags: () => [{ type: 'Dictionary', id: 'LIST' }],
    }),
    editDictionary: builder.mutation<Dictionary, EditArgs>({
      query: ({ id, dictionary }) => ({
        url: `${commonUrl}/${id}`,
        method: 'PUT',
        body: dictionary,
      }),
      invalidatesTags: () => [{ type: 'Dictionary', id: 'LIST' }],
    }),
    deleteDictionary: builder.mutation<Dictionary, string>({
      query: (id: string) => ({
        url: `${commonUrl}/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: () => [{ type: 'Dictionary', id: 'LIST' }],
    }),
    getAllGroups: builder.query({
      query: () => ({
        url: `${commonUrl}/all-groups`,
      }),
      providesTags: () => [{ type: 'Dictionary', id: 'LIST' }],
    }),
    changeDictionaryInactivity: builder.mutation<Dictionary, string>({
      query: (id: string) => ({
        url: `${commonUrl}/change-inactive/${id}`,
        method: 'PUT',
      }),
      invalidatesTags: () => [{ type: 'Dictionary', id: 'LIST' }],
    }),
    getImportDictionary: builder.query<ImportDictionary, void>({
      query: () => ({
        url: `${commonUrl}/import`,
      }),
      providesTags: () => [{ type: 'Dictionary', id: 'LIST' }],
    }),
    getNestedDictionary: builder.query<NestedDictionary, string>({
      query: (groupName: string) => ({
        url: `${commonUrl}/nested`,
        params: { groupName },
      }),
      providesTags: () => [{ type: 'Dictionary', id: 'LIST' }],
    }),
  }),
})

type EditArgs = {
  id: string
  dictionary: Partial<Dictionary>
}

export interface DictionaryLightDTO {
  id: string
  value: string
}

export type NestedDictionary = {
  nestedDictionary: Record<string, Record<string, DictionaryLightDTO>>
}

export const {
  useGetDictionariesQuery,
  useGetDictionaryQuery,
  useCreateDictionaryMutation,
  useDeleteDictionaryMutation,
  useEditDictionaryMutation,
  useGetAllGroupsQuery,
  useChangeDictionaryInactivityMutation,
  useGetImportDictionaryQuery,
  useGetNestedDictionaryQuery,
} = extendedApiSlice